import TokenService from "../services/TokenService";
import {SuccessMessage} from "../constants";
import React, { useEffect, useState } from "react";
import {redirect, useNavigate} from "react-router-dom"
import HeaderMenu from "./HeaderMenu"




function Index() {
    const [authorized, setAuthorized] = useState(false);
    const navigate = useNavigate();

    useEffect(()=> {
        TokenService.checkAuth().then((response) => {
            if (response.data.Success == SuccessMessage) {
                setAuthorized(true)
            }
        })
    }, [])

    if (!authorized) {
        return (<div>Not authorized</div>)
    }
    return (
        <div>
            <HeaderMenu/>
        </div>
    )
}

export default Index